import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import CollectionStaffReport from "../components/collectionStaffsReport.jsx";
import Footer from "../components/footer.jsx";

function CollectionStaffReportpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <CollectionStaffReport/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default CollectionStaffReportpage;
